import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import '../css/style.css'
import '../css/reset.css'
import '../css/responsive.css'
import '../css/glightbox.css'
import '../Pages/PrivacyPolicy.css'
import { useTranslation } from 'react-i18next'
import { sendDeleteAccountOtp, verifyOtpAndDeleteUser } from '../services/authService';
import React, { useState } from 'react'

function DeleteAccount() {

    const { t } = useTranslation();

    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState(['', '', '', '']);
    const [step, setStep] = useState(1);
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);
    const [countryCode, setCountryCode] = useState("+966");


    const handleSendOtp = async () => {

        if (!phone) return;

        setLoading(true);

        try {

            await sendDeleteAccountOtp({ PhoneNumber: phone });

            setStep(2);

        } catch (error) {

            if (error.response?.status === 404) {

                setAlert({
                    type: 'error',
                    message: t('privacy.phoneNotFound')
                });

            } else {

                setAlert({
                    type: 'error',
                    message: t('privacy.somethingWrong')
                });

            }

        }

        setLoading(false);

    };


    const handleVerifyOtp = async () => {

        const finalOtp = otp.join('');

        if (finalOtp.length !== 4) return;

        setLoading(true);

        const res = await verifyOtpAndDeleteUser({
            PhoneNumber: phone,
            Otp: finalOtp,
        });

        setLoading(false);

        if (res?.error) {

            setAlert({ type: 'error', message: res.error });

        } else {

            setAlert({
                type: 'success',
                message: t('privacy.deleteSuccess')
            });

        }

    };


    const handleOtpChange = (value, index) => {

        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            document.getElementById(`otp-${index + 1}`).focus();
        }

    };


    return (

        <>

            <Header />

            <section
                class="banners"
                style={{ backgroundImage: `url(${'../../images/banners_bg.webp'})` }}
            >

                <div class="container">

                    <div class="banner_head">

                        <h1>{t("privacy.Title11")}</h1>

                    </div>

                    <div class="bredcrub">

                        <a href="/"> {t("header.home")} </a>
                        <span> <img src="/images/arrow.png" alt="arrow" /></span>

                        <p>{t("privacy.Title11")}</p>

                    </div>

                </div>

            </section>


            <section class="term_condition">

                <div class="container">

                    <div class="condition_contents">

                        <div class="term_heading">

                            <h2>{t("privacy.Title11")}</h2>

                            <p>{t("privacy.deleteAccountDescription")}</p>

                        </div>


                        {alert && (
                            <div className={`alert ${alert.type}`}>
                                {alert.message}
                                <span onClick={() => setAlert(null)}>×</span>
                            </div>
                        )}


                        {step === 1 && (

                            <>

                                <h3 className="box_heading">{t('privacy.enterPhone')}</h3>

                                <div className="form_group">

                                    <div className="phone_box">

                                        <select
                                            value={countryCode}
                                            onChange={(e) => setCountryCode(e.target.value)}
                                            className="d-block"
                                        >

                                            <option value="+966">+966</option>
                                            <option value="+1">+1</option>
                                            <option value="+20">+20</option>

                                        </select>

                                        <input
                                            type="text"
                                            value={phone}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, '');
                                                setPhone(onlyNumbers);
                                            }}
                                            maxLength="9"
                                            placeholder={t('privacy.phonePlaceholder')}
                                            className="d-block"
                                        />

                                    </div>

                                </div>

                                <button
                                    onClick={handleSendOtp}
                                    disabled={loading}
                                    className="login_button"
                                >

                                    {loading ? t('privacy.loading') : t('privacy.next')}

                                </button>

                            </>

                        )}


                        {step === 2 && (

                            <>

                                <h3 style={{ textAlign: "center", marginBottom: "15px" }}>{t('privacy.enterOtp')}</h3>

                                <div className="otp-container">

                                    {otp.map((digit, index) => (

                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) =>
                                                handleOtpChange(e.target.value, index)
                                            }
                                            className="otp-input"
                                        />

                                    ))}

                                </div>

                                <button
                                    onClick={handleVerifyOtp}
                                    disabled={loading}
                                    className="login_button"
                                >

                                    {loading ? t('privacy.loading') : t('privacy.confirm')}

                                </button>

                            </>

                        )}

                    </div>

                </div>

            </section>

            <Footer />

        </>

    )

}

export default DeleteAccount